import { motion } from 'framer-motion'
import { Glasses } from 'lucide-react'
import { Button } from '@src/components/ui/button'
import { cn } from '@src/lib/tailwind.utils'

export interface InterpretToggleProps {
  active: boolean
  onClick: () => void
}

export const InterpretToggle = ({ active, onClick }: InterpretToggleProps) => (
  <Button
    type="button"
    variant="outline"
    size="sm"
    className={cn('gap-1.5 px-3 text-xs text-primary', active && 'bg-cyan-50')}
    aria-pressed={active}
    onClick={onClick}
  >
    <Glasses className="size-3.5" />
    Interpret
  </Button>
)

export interface InterpretPanelProps {
  children: React.ReactNode
}

export const InterpretPanel = ({ children }: InterpretPanelProps) => (
  <motion.div
    initial={{ opacity: 0, height: 0, y: -4 }}
    animate={{ opacity: 1, height: 'auto', y: 0 }}
    exit={{ opacity: 0, height: 0, y: -4 }}
    transition={{
      height: {
        duration: 0.3,
        ease: 'easeOut',
      },
      y: {
        duration: 0.25,
        ease: 'easeOut',
      },
      opacity: {
        duration: 0.3,
        delay: 0.3,
        ease: 'easeOut',
      },
    }}
    className="overflow-hidden"
  >
    <div className="mb-4 rounded-md bg-neutral-100 p-4 text-sm text-foreground">{children}</div>
  </motion.div>
)
